export default __webpack_public_path__ + "static/media/policy.d1acb948.svg";